const config = {
  reports_progress_statuses: {
    ui: ['filter', 'export'],
  },
  reports_progress_milestone: {
    ui: ['yearSwitch', 'filter', 'export'],
  },
  reports_progress_schedule: {
    ui: ['dropdown', 'filter', 'export'],
  },
  reports_progress_portfolio: {
    ui: ['filter', 'export'],
  },
  reports_progress_month: {
    ui: ['range', 'dropdown', 'filter', 'export'],
  },
  reports_budget_project: {
    ui: ['range', 'dropdown', 'filter', 'export'],
  },
  reports_budget_month: {
    ui: ['range', 'dropdown', 'filter', 'export'],
  },
  reports_time_project: {
    ui: ['range', 'dropdown', 'filter', 'export'],
  },
  reports_time_month: {
    ui: ['range', 'dropdown', 'filter', 'export'],
  },
};

export default {
  getConfig(routerPath) {
    if (routerPath in config) {
      return config[routerPath];
    }

    return {};
  },
};
